import { Wrapper } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.div`
  ${({ displayState }) => css`
    position: absolute;
    min-width: ${displayState?.enableFullWidth ? null : "320px"};
    background: #FFFFFF;
    box-sizing: border-box;
    box-shadow: 0px 1px 2px rgb(0 0 0 / 8%);
    z-index: 10;
    margin-top: 5px;
    border: 1px solid #E3E3E3;
    border-radius: 8px;
    left: ${displayState?.left ? displayState.left + 'px' : 'unset'};
  `}
`

export default Wrapper(template)